import axios from "axios";
import { store } from './../store/index'

export const server = {
  baseURL: ''
}

const instance = axios.create({
  baseURL: 'https://pemph81t96.execute-api.us-west-2.amazonaws.com/Stage/',
  // For local tests.
  // baseURL: 'http://127.0.0.1:3000/',
  timeout: 10000,
});

instance.interceptors.request.use(
  function(config) { 
    config.headers.common.Authorization = store.getters.authToken;
    return Promise.resolve(config);
   });

export default class RestHelper {
  constructor() {}

  static getAllUsersInfo() {
    return instance.get(`list_users`);
  }

  static getAvailableLidars() {
    return instance.get('list_lidars');
  }

  static getAllAllowFeatures() {
    return instance.get('list_allow_features');
  }

  static getUserInfo(sub_id) {
    return instance.get(`get_user?sub_id=${sub_id}`);
  }

  static renameLicense(sub_id, license_id, new_name) { 
    return instance.put(`set_license_name?sub_id=${sub_id}&license_id=${license_id}`, 
      { name : new_name });
  }

  static updateLicense(sub_id, license_id, expiration_date, max_lidar_count, allow_gpu_algo_node, max_algo_node_count, lidars_license, allow_features_in) { 
    return instance.put(`set_license_properties?sub_id=${sub_id}&license_id=${license_id}`, 
      {
        expiration_date : expiration_date,
        max_lidar_count: max_lidar_count,
        allow_gpu_algo_node: allow_gpu_algo_node,
        max_algo_node_count: max_algo_node_count,
        hardware_allowance: lidars_license,
        allow_features : allow_features_in
      });
  }

  static addLicense(sub_id, expiration_date, max_lidar_count, allow_gpu_algo_node, max_algo_node_count, lidars_license, allow_features_in) { 
    return instance.post(`add_license?sub_id=${sub_id}`, 
      {
        expiration_date : expiration_date,
        max_lidar_count: max_lidar_count,
        allow_gpu_algo_node: allow_gpu_algo_node,
        max_algo_node_count: max_algo_node_count,
        hardware_allowance: lidars_license,
        allow_features : allow_features_in
      });
  }

  static uploadLicenseFile(license_id, data) {
    return instance.post(`upload_license_key?sub_id=${store.getters.currentUserSub}&license_id=${license_id}`, 
    { id : data }); 
  }

  static downloadLicenseFile(license_id) {
    return instance.get(`download_license_file?sub_id=${store.getters.currentUserSub}&license_id=${license_id}`); 
  }

  static deleteLicenseFile(sub_id, license_id) {
    return instance.delete(`remove_license?sub_id=${sub_id}&license_id=${license_id}`); 
  }


}
